import React, { useState, useRef, useEffect } from 'react'
/* import { useForm } from 'react-hook-form' */
import ReCAPTCHA from "react-google-recaptcha";
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import ModalHeader from 'react-bootstrap/ModalHeader'
import ModalTitle from 'react-bootstrap/ModalTitle'
import ModalBody from 'react-bootstrap/ModalBody'
import ModalFooter from 'react-bootstrap/ModalFooter'
import useForm from './useForm'
import validate from './FormValidationRules';
import configData from '../../../temp/config'
import { postDataFetcher } from '../../../dataFetcher'
import CONFIG_OBJECT from '../../../config/config'
import App_Constants from '../../../app-constants/App_Constants'
import { withTranslation } from 'react-i18next'
import './Popup.css';
import { html } from 'd3';

function Popup(props) {

    /* const { register, handleSubmit, errors } = useForm();    
    const onSubmit = (data, e) => alert(data, e); */

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(login, validate,props);

    const [esubject] = useState(props.emailsubject)
    const [capstatus, setCapstatus] = useState(false)
    const [detailpop, setDetailpop] = useState(props.show)
    const [popmessage, setPopmessage] = useState()

    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
        props.handleClose()
    }
    const handleShow = () => setShow(true);

    const [iemtid, setItemid] = useState()

    const { t } = props;

    useEffect(() => {
        values.subject = esubject
        setItemid(props.itemid)
    },[])

    function captchahahandleChange(value) {
        value && setCapstatus(true)
    }
    function login() {
        let toaddr = values.toemail.split(',');
        //let toaddresses = toaddr.map(addr => { return `"${addr}"` })        
        let data = {
            from:values.fromemail,
            to:toaddr,
            subject:values.subject, 
            message:values.note, 
            itemId:`{${iemtid}}`
        }
        postDataFetcher(`${CONFIG_OBJECT.RFEMAIL_REST_URL}${App_Constants.SC_API_KEY}`, data)
        .then(res => {
            //props.handleClose()
          if (res.data.HasError) {
            //console.log(res.data.HasError)
            setShow(false)
            setDetailpop(false)            
            setShow(true)
            setPopmessage(res.data.HasError)
          } else {
            setShow(false)
            setDetailpop(false)            
            setShow(true)
            setPopmessage(t('Common_SendEmailSuccessful'))
          }          
        }, err => {
          console.log(err);
            setShow(false)
            setDetailpop(false)            
            setShow(true)
            setPopmessage(err)
        });
    }
    function validateToEmail() {
        var emailRegEx = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        var str = document.getElementById("toemail_val").value;
        var array = str.split(/[,]+/);           
        for (var i = 0; i < array.length; i++) {
            var email = array[i];
            if (!email.match(emailRegEx)) {
                document.getElementById("toerror").innerHTML = t('Common_ToEmailInvalid');
                return false;
            }
            else {
                document.getElementById("toerror").innerHTML = "";
            }
        }
        return true
    }
    function validateFromEmail() {
        var emailRegEx = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        var str = document.getElementById("fromemail_val").value;
        var array = str.split(/[,]+/);           
        for (var i = 0; i < array.length; i++) {
            var email = array[i];
            if (!email.match(emailRegEx)) {
                document.getElementById("fromerror").innerHTML = t('Common_FromEmailInvalid');
                return false;
            }
            else {
                document.getElementById("fromerror").innerHTML = "";
            }
        }
        return true
    }
    function email(event) {
        var emailRegEx = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        var array, str;
        var count = 5;
        var key_code = event.which || event.keyCode;       
        
        if (key_code == 32 || key_code == 59) {
            event.preventDefault()
            return false;
        }
         if (key_code == 44|| key_code == 59) {    
            str = document.getElementById("toemail_val").value;
            array = str.split(/[,]+/);
            for (var i = 0; i < array.length; i++) {
                var email = array[i];
                if (!email.match(emailRegEx)) {
                    document.getElementById("toerror").innerHTML = t('Common_ToEmailInvalid');
                    return false;
                }
            }
            if (array.length === count) {
                document.getElementById("toerror").innerHTML = t('Common_ToEmailCountInvalid');
                event.preventDefault();                 
                return false;
            }
        }        
    }

    function fromemailvalidation(event){
        var emailRegEx = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        var array, str;
        var count = 1;
        var key_code = event.which || event.keyCode;
       console.log(key_code)

        if (key_code == 32 || key_code == 59) {
            event.preventDefault()
            return false;
        }
         if (key_code == 44) {    
            str = document.getElementById("fromemail_val").value;
            array = str.split(/[;,]+/);
            for (var i = 0; i < array.length; i++) {
                var email = array[i];
                if (!email.match(emailRegEx)) {
                    document.getElementById("fromerror").innerHTML = t('Common_FromEmailInvalid');
                    return false;
                }
            }
            if (array.length === count) {
                document.getElementById("fromerror").innerHTML = t('Common_FromEmailCountInvalid');
                event.preventDefault();                 
                return false;
            }
        }  
    }

    

    return (   
        <>     
        <Modal 
            className="modal-recipe"
            show={detailpop}
            onHide={props.handleClose} 
            animation={false}>           
            <form onSubmit={handleSubmit} noValidate>
                <ModalHeader closeButton>
                    <ModalTitle>{t('Common_SendEmailTitle')}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                
                <div className="field">
                    <label className="label">{t('Common_ToEmail')}</label>
                    <div className="control">
                    <input id="toemail_val" multiple autoComplete="off" className={`input ${errors.toemail && 'is-danger'}`} name="toemail" onKeyPress={email} onBlur={validateToEmail} onChange={handleChange} value={values.toemail || ''} required />
                    {/* <input multiple autoComplete="off" className={`input ${errors.toemail && 'is-danger'}`} type="email" multiple name="toemail" onChange={handleChange} value={values.toemail || ''} required /> */}
                    {errors.toemail && (
                        <p className="help is-danger">{errors.toemail}</p>
                    )}
                    <p id="toerror" className="help is-danger"></p>
                    </div>
                </div>
                <div className="field">
                    <label className="label">{t('Common_FromEmail')}</label>
                    <div className="control">
                    <input id="fromemail_val" autoComplete="off" className={`input ${errors.fromemail && 'is-danger'}`} type="email" name="fromemail" onKeyPress={fromemailvalidation} onBlur={validateFromEmail} onChange={handleChange} value={values.fromemail || ''} required />
                    {errors.fromemail && (
                        <p className="help is-danger">{errors.fromemail}</p>
                    )}
                    <p id="fromerror" className="help is-danger"></p>
                    </div>
                </div>
                <div className="field">
                    <label className="label">{t('Common_Subject')}</label>
                    <div className="control">
                    <input id="emailsubject" className={`input ${errors.subject && 'is-danger'}`} type="textfield" name="subject" onChange={handleChange} value={values.subject || '' } required />
                    </div>
                    {errors.subject && (
                    <p className="help is-danger">{errors.subject}</p>
                    )}
                </div>
                <div className="field">
                    <label className="label">{t('Common_Note')}</label>
                    <div className="control">
                    <textarea rows="4" className={`input ${errors.note && 'is-danger'}`} type="textarea" name="note" onChange={handleChange} value={values.note || ''} required />
                    </div>
                    {errors.note && (
                    <p className="help is-danger">{errors.note}</p>
                    )}
                </div>
                <div className="recaptchablk">
                    <ReCAPTCHA
                        sitekey={props.recaptchasitekey}
                        name="recaptcha"
                        onChange={captchahahandleChange}
                    />
                </div>
                </ModalBody>
                <ModalFooter>
                    <Button type="submit" className="btn blk-btn" disabled={!capstatus} >{t('Common_SendButton')}</Button>
                </ModalFooter>   
                </form>                  
        </Modal>
        {
            show && 
            <Modal 
            className="modal-email-success"
            animation={false}
            show={show} 
            onHide={handleClose}
            >        
                <ModalHeader closeButton>
                    
                </ModalHeader>
                <ModalBody>
                    <img className="thumbsup" src={`${configData.sitecoreApiHost}/${t(`Common_EmailSuccessImage`)}`} />
                    <ModalTitle>{popmessage}</ModalTitle>
                    <Button onClick={handleClose}>{t('Common_GotItButton')}</Button>
                </ModalBody>
            </Modal>
        }
        </>
    );
}

export default withTranslation()(Popup);